import { render, staticRenderFns } from "./CouponPopup.vue?vue&type=template&id=9aefed90"
import script from "./CouponPopup.vue?vue&type=script&lang=ts"
export * from "./CouponPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports